import log from "loglevel";
log.log("--------------------=================================");
log.log(process.env.REACT_APP_API_URL);
log.log("--------------------=================================");
const {
  REACT_APP_API_URL,
  REACT_APP_ENABLE_SIGNUP_CONFIRMATION,
  REACT_APP_SIGNUP_SHOW_ROLL_NO,
  REACT_APP_SIGNUP_SHOW_EMPLOYEE_CODE,
} = process.env;



// seconds
export const session_out_time = 1800000;
export const base_url = REACT_APP_API_URL;

export const monitoring_base_url = "http://0.0.0.0:3032";

export const google_client_id = "426536665174-0di6bf9pc6dujrim1j4obqa9n89afe8r.apps.googleusercontent.com";

log.log(process.env);

// intelligent grading status check interval
export const ai_status_check_interval = 30000;

export const videoAcceptedFiles = {
  'video/x-msvideo': ['.avi'],
  'video/mp4': ['.mp4'],
  'video/mpeg': ['.mpeg'],
  'video/ogg': ['.ogv'],
  'video/mp2t': ['.ts'],
  'video/webm': ['.webm'],
  'video/3gpp': ['.3gpp']
}

export const quizAcceptedFiles = {
  'text/csv': ['.csv'],
  'text/plain': ['.txt'],
  'application/vnd.oasis.opendocument.text': ['.odt']
}

export const imageAcceptedFiles = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/svg+xml': ['.svg'],
  'image/tiff': ['.tiff', '.tif'],
  'image/webp': ['.webp'],
  'image/vnd.microsoft.icon': ['.ico'],
  'image/bmp': ['.bmp']
}

export const skeletonCount = 8

export const feedBackFormURL = 'https://forms.gle/rNU798gpQ5gswyhY8'

// feature flags
export const enableRoleDisplayInNavbar = true;
export const enableSignupConfirmation = REACT_APP_ENABLE_SIGNUP_CONFIRMATION === 'true';
export const enableSignupRollNo = REACT_APP_SIGNUP_SHOW_ROLL_NO === 'true';
export const showEmployeeCode = REACT_APP_SIGNUP_SHOW_EMPLOYEE_CODE === 'true';
export const signupRollNoLabel = showEmployeeCode ? "Employee Code" : "Roll No.";
